import { AlertListItem } from './AlertListItem';
import { EventListItem } from './EventListItem';
import { IncidentListItem } from './IncidentListItem';
import { LocationListItem } from './LocationListItem';
import { ObjectiveListItem } from './ObjectiveListItem';
import { PersonListItem } from './PersonListItem';
import { ExternalPersonListItem } from './ExternalPersonListItem';
import { ExternalVehicleListItem } from './ExternalVehicleListItem';
import { VehicleListItem } from './VehicleListItem';

export function ListItem({ tab, ...props }) {
  switch (tab) {
    case 'vehicles':
      return <VehicleListItem {...props} />;
    case 'people':
      return <PersonListItem {...props} />;
    case 'locations':
      return <LocationListItem {...props} />;
    case 'incidents':
      return <IncidentListItem {...props} />;
    case 'objectives':
      return <ObjectiveListItem {...props} />;
    case 'events':
      switch (props.feature?.properties?.eventType) {
        case 'ACCELEROMETERALERT':
          return <AlertListItem {...props} />;
        case 'ACCELEROMETEREVENT':
          return <EventListItem {...props} />;
        default:
          return null;
      }
    case 'externalVehicles':
      return <ExternalVehicleListItem {...props} />;
    case 'externalPeople':
      return <ExternalPersonListItem {...props} />;
    default:
      return null;
  }
}
